import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { testimonials } from '../../data/testimonials';
export function TestimonialsSection() {
  return <section className="bg-cream-deep px-5 py-20 md:py-28" data-id="element-176" data-mp="1rv5y0y519t4m">
      <div className="mx-auto max-w-5xl" data-id="element-177" data-mp="1rtl3v9mmsc7a">
        <SectionHeading title="Lo que dicen sobre el kit" data-id="element-178" data-mp="1mxcuydz11f8k" />
        <ul className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-179" data-mp="1muqnsfg1t1qv">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-2xl border border-line bg-white p-7 md:p-9" data-id="element-180" data-mp="1iwavbw177162">
              <div className="flex gap-1 text-honey" role="img" aria-label="5 de 5 estrellas" data-id="element-181" data-mp="1dxzjjfrcegl7">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-182" data-mp="13ys6yusfmpz5" data-mpi={i} />)}
              </div>
              <blockquote className="mt-5 font-serif text-lg leading-relaxed text-ink md:text-xl" data-id="element-183" data-mp="339jmo57m2clp">«{t.quote}»</blockquote>
              <p className="mt-auto pt-6 text-sm" data-id="element-184" data-mp="2y9nf5vzpg31e">
                <span className="block text-base font-semibold text-ink" data-id="element-185" data-mp="1t9do97myazlw">{t.name}</span>
                <span className="block text-ink-muted" data-id="element-186" data-mp="1y99iif5ujco9">{t.role} · {t.city}</span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}